import React from 'react'

import { StyledDecorativeHeading, StyledHeading, Diamond } from './styles'

import diamonds from './../../../img/heading-diamonds.png'

const DecorativeHeading = ({ children, diamond = true, leaves = true, ...props }) => (
  <StyledDecorativeHeading>
    {diamond && <Diamond src={diamonds} />}

    <StyledHeading {...props} leaves={leaves}>
      {children}
    </StyledHeading>
  </StyledDecorativeHeading>
)

export default DecorativeHeading
